import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Box } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { deepOrange, deepPurple } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DetailsIcon from '@material-ui/icons/Details';
import PrintIcon from '@material-ui/icons/Print';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import { imprimirPacoteMalote } from '../../../services/impressora';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: 'pointer',
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
}));

const ActionsField = ({ handleEfetivar, handleShow, handleDeletar, ...rest }) => {
  const record = useRecordContext(rest);
  const statusValue = record ? record.record.visible : false;
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  async function imprimir(id) {
    if (id > 0) {
      const codigo = await imprimirPacoteMalote(id, '?label=Troco');
      if (codigo < 0) {
        enqueueSnackbar('Erro ao imprimir a nota!', {
          variant: 'error',
        });
      }
    }
  }

  return (
    <div
      style={{
        marginRight: '0px',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      {/* {statusValue ? (
        <Tooltip title="Ajustar" placement="bottom" aria-label="add2">
          <IconButton
            aria-label="check"
            size="small"
            onClick={() => handleEfetivar(record)}
          >
            {statusValue ? <CheckCircleOutlineIcon /> : <CancelIcon />}
          </IconButton>
        </Tooltip>
      ) : (
        <div />
      )} */}
      {statusValue ? (
        <Tooltip
          title="Converter em sangria"
          placement="bottom"
          aria-label="add2"
        >
          <Box>
            <Avatar
              className={classes.orange}
              onClick={() => handleEfetivar(record)}
            >
              S
            </Avatar>
          </Box>
        </Tooltip>
      ) : (
        <div />
      )}
      <Tooltip title="Detalhes" placement="bottom" aria-label="add2">
        <IconButton
          aria-label="detalhes"
          size="small"
          onClick={() => handleShow(record)}
        >
          <DetailsIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Imprimir" placement="bottom" aria-label="add2">
        <IconButton
          aria-label="imprimir"
          size="small"
          onClick={() => imprimir(record ? record.record.id : -1)}
        >
          <PrintIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Excluir" placement="bottom" aria-label="excluir2">
          <IconButton
            aria-label="excluir"
            size="small"
            onClick={() => handleDeletar(record)}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>
    </div>
  );
};

ActionsField.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default ActionsField;
